exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-info{background-color:var(--info) !important}.base-select-group{display:flex;flex-direction:column;margin-bottom:25px}select:has(option[value=\"\"]:checked){color:var(--gray)}.select-loading-spinner{color:var(--gray);position:absolute;top:40%;right:25px;transform:translateY(-50%);pointer-events:none}", ""]);

// exports
